(() => {
  const init = () => {
    const marker = document.querySelector('[data-sd-collection-theme]');
    const main = document.getElementById('MainContent');
    if (!marker || !main || main.dataset.sdCollectionReady === 'true') return;
    main.dataset.sdCollectionReady = 'true';
    const header = document.querySelector('header.sd-header');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 94;
      main.style.setProperty('--sd-filter-top', `${Math.ceil(bottom + 18)}px`);
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    update();
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(schedule).observe(header);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

// A failed section response must not remove the collection's filter controls.
(() => {
  if (!document.querySelector('[data-sd-collection-theme]')) return;
  customElements.whenDefined('facet-filters-form').then(() => {
    const Filters = customElements.get('facet-filters-form');
    if (!Filters || Filters.sdCollectionGuard) return;
    Filters.sdCollectionGuard = true;
    const renderSection = Filters.renderSection;
    const reloadResults = () => {
      const params = Filters.searchParamsPrev || '';
      location.replace(`${location.pathname}${params ? `?${params}` : ''}`);
    };
    Filters.renderSection = function (html, event, updateEvent) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (!parsed.getElementById('ProductGridContainer') || !parsed.getElementById('ProductCount')) {
        reloadResults();
        return;
      }
      try {
        return renderSection.call(this, html, event, updateEvent);
      } catch (error) {
        reloadResults();
      }
    };
  });
})();

(() => {
 if (!document.querySelector('[data-sd-collection-theme]')) return;
 const setPickerSpace = event => {
  const select = event.target.closest?.('select[name="sort_by"]');
  if (!select) return;
  const rect = select.getBoundingClientRect();
  select.style.setProperty('--sd-picker-space', Math.max(44, innerHeight - rect.bottom - 18) + 'px');
  select.style.setProperty('--sd-picker-top', (rect.bottom + 7) + 'px');
  const width = Math.min(Math.max(185, rect.width), innerWidth - 16);
  select.style.setProperty('--sd-picker-left', Math.max(8, Math.min(rect.left, innerWidth - width - 8)) + 'px');
  select.style.setProperty('--sd-picker-width', width + 'px');
 };
 document.addEventListener('pointerdown', setPickerSpace, true);
 document.addEventListener('focusin', setPickerSpace, true);
 document.addEventListener('keydown', setPickerSpace, true);
})();
